import React from 'react';
import BankImportPage from './BankImportPage';

export default function UbsPage() {
  // Dynamic endpoint based on account currency
  const getListEndpoint = (selectedAccount) => {
    if (!selectedAccount) return '/api/ubs/eur';
    return selectedAccount.currency === 'CHF' ? '/api/ubs/chf' : '/api/ubs/eur';
  };

  const getImportEndpoint = (selectedAccount) => {
    if (!selectedAccount) return '/api/ubs/import/eur';
    return selectedAccount.currency === 'CHF' ? '/api/ubs/import/chf' : '/api/ubs/import/eur';
  };

  return (
    <BankImportPage
      title="UBS Import"
      description="Upload a UBS CSV file and view the UBS register in one place."
      fieldLabels={['Date', 'Description', 'Amount', 'Balance']}
      listEndpoint={getListEndpoint}
      importEndpoint={getImportEndpoint}
      bankId="UBS"
      emptyText="No UBS records found."
      exchangeRate={{
        settingKey: 'ubs_chf_exchange_rate',
        label: '1 CHF = ? EUR',
        defaultValue: '1'
      }}
    />
  );
}
